import { FullBooking } from '@alluradirect/react';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { ReservationTimeline } from 'scenes/dashboard/views/Reservation/components/ReservationTimeline';

interface Props {
  booking: FullBooking | undefined;
}

export const CheckoutImportantUpcomingDates = ({ booking }: Props) => {
  const timeline = booking?.TIMELINE ?? [];

  return (
    <>
      <Grid item xs={12}>
        <CheckoutSectionTitle>Important Upcoming Dates</CheckoutSectionTitle>
      </Grid>
      <Grid item xs={12}>
        <ReservationTimeline timeline={timeline} />
      </Grid>
    </>
  );
};
